import ApiService from '@api/api-service';

let VCA = VCA || {};

VCA.PatientDocumentsPetPage = (function ($) {

    let ui = {};

    function cacheUI() {
        ui.$TabBtn = $('.js-patient-docs-btn');
        ui.$TabContent = $('.petpage-patient-docs__content');
        ui.$DisplayTitle = $('.petpage-patient-docs__title');
        ui.$CareInstructionsPdfBtn = $('.petpage-patient-docs__pdf-download.care-instructions');
        ui.$VaccineRecordsPdfBtn = $('.petpage-patient-docs__pdf-download.vaccine-records');
        ui.$TestResultsPdfBtn = $('.petpage-patient-docs__pdf-download.test-results');
        ui.$LoadingSpinner = $('.petpage-patient-docs__loading-spinner');
        ui.$PetId = petId;
    }

    function bindEvents() {
        ui.$TabBtn.on('click', displayContent);
        ui.$CareInstructionsPdfBtn.on('click', initCareInstructionsBtn);
        ui.$VaccineRecordsPdfBtn.on('click', initVaccineRecordsBtn);
        ui.$TestResultsPdfBtn.on('click', initTestResultsBtn);
    }

    function displayContent(e) {
        e.preventDefault();

        const btn = $(e.currentTarget);
        const tabNumber = btn.data('nav');
        const tabName = btn.data('name');
        const contentContainer = $('.petpage-patient-docs__content-container');
        const contentToActivate = $(contentContainer).find(`.petpage-patient-docs__content[data-nav-content="${tabNumber}"]`)[0];
        let tabBtnIsActive = btn.hasClass('active');

        if (tabBtnIsActive) {
            return;
        }

        ui.$TabBtn.each((idx,btn) => {
            $(btn).removeClass('active');
        });

        ui.$TabContent.each((idx,content) => {
            $(content).removeClass('active');
        });

        btn.addClass('active');
        $(contentToActivate).addClass('active');
        ui.$DisplayTitle.text(tabName);
    }

    function resetBtnAndLoader() {
        $('.petpage-patient-docs__pdf-download').each((idx,btn) => {
            $(btn).show();
        });

        ui.$LoadingSpinner.each((idx,loader) => {
            $(loader).hide();
        });
    }

    function initCareInstructionsBtn(e) {
        let btn = $(e.currentTarget);
        let documentId = btn.data('documentid');
        let titleOfPDF = btn.data('title');
        let loadingSpinner = btn.closest('.info').find('.petpage-patient-docs__loading-spinner');

        btn.hide();
        loadingSpinner.show();
        downloadCareInstructionsPdf(documentId,titleOfPDF);
    }

    function initVaccineRecordsBtn(e) {
        let btn = $(e.currentTarget);
        let documentId = btn.data('documentid');
        let titleOfPDF = btn.data('title');
        let loadingSpinner = btn.closest('.info').find('.petpage-patient-docs__loading-spinner');
        let url = '/myvca-api/get-vaccine-record-document';

        btn.hide();
        loadingSpinner.show();
        downloadPdf(url,petId,documentId,titleOfPDF);
    }

    function initTestResultsBtn(e) {
        let btn = $(e.currentTarget);
        let documentId = btn.data('documentid');
        let titleOfPDF = btn.data('title');
        let loadingSpinner = btn.closest('.info').find('.petpage-patient-docs__loading-spinner');
        let url = '/myvca-api/get-diagnostic-document';

        btn.hide();
        loadingSpinner.show();
        downloadPdf(url,petId,documentId,titleOfPDF);
    }

    async function downloadCareInstructionsPdf(documentId, titleOfPDF) {    
    
        const url = '/myvca-api/get-care-instruction-document';
        let api = new ApiService(url);
        let query = { documentId };
        const { data, success, error } = await api.query(query);

        if (!success || (error !== null && error !== '')) {
            resetBtnAndLoader();
            alert(`Sorry, this document is not available. ${error}`);
            console.log(`Status: ${error}`);
        } else { 
            resetBtnAndLoader();

            let response = data;
            var pdfWindow = window.open("");
            pdfWindow.document.write(`<html<head><title>${titleOfPDF}</title><style>body{margin: 0px;}iframe{border-width: 0px;}</style></head>`);
            pdfWindow.document.write('<html><body><object data="' + response + '" type="application/pdf" width="100%" height="100%"></object>');
        }
    }


    async function downloadPdf(urlPath, petId, documentId, titleOfPDF) {
        const url = urlPath;
        let api = new ApiService(url);
        let query = { petId, documentId };
        const { data, success, error } = await api.query(query);

        if (!success || (error !== null && error !== '')) {
            resetBtnAndLoader();
            alert(`Sorry, this document is not available. ${error}`);
            console.log(`Status: ${error}`);
        } else { 
            resetBtnAndLoader();

            let response = data;
            var pdfWindow = window.open("");
            pdfWindow.document.write(`<html<head><title>${titleOfPDF}</title><style>body{margin: 0px;}iframe{border-width: 0px;}</style></head>`);
            pdfWindow.document.write('<html><body><object data="' + response + '" type="application/pdf" width="100%" height="100%"></object>');
        }
    }


    function init() {
        if ($('.petpage-patient-docs').length <= 0) {
            return;
        }

        cacheUI();
        bindEvents();
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    $(document).ready(function() {
        VCA.PatientDocumentsPetPage.init();
    });
});
